import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

// Removed TypeScript interfaces

const initialState = {
  logs: [],
  totalCount: 0,
  loading: false,
  error: null,
  page: 1,
  pageSize: 10,
};

export const fetchAuditLogs = createAsyncThunk(
  'auditTrail/fetchAuditLogs',
  async (params, thunkAPI) => {
    try {
      const { page = 1, pageSize = 10, search = '' } = params;
      const response = await api.get('/admin/audit-logs', {
        params: {
          page,
          pageSize,
          search,
        },
      });
      // Map response data if needed here or in component
      const payload = response.data?.data ?? response.data;
      return {
        logs: payload.logs ?? [],
        totalCount: payload.totalCount ?? 0,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || 'Failed to fetch audit logs');
    }
  }
);

const auditTrailSlice = createSlice({
  name: 'auditTrail',
  initialState,
  reducers: {
    setPage(state, action) {
      state.page = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAuditLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = action.payload.logs;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(fetchAuditLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setPage, setPageSize } = auditTrailSlice.actions;

export default auditTrailSlice.reducer;
